import routerOptions0 from "/builds/campinginfo/civ2-nuxt-3/node_modules/.pnpm/nuxt@4.1.2_@parcel+watcher@2.5.1_@types+node@24.5.1_@vue+compiler-sfc@3.5.21_db0@0.3.2__9481da25d3efbdc4ae37683a20505ab7/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/builds/campinginfo/civ2-nuxt-3/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions1.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}